@if (showSpinner) {
  <app-loader></app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('view')) {
    <div class="container-fluid mb-4">
      <div class="row" style="padding-top: 10px !important; padding-bottom: 20px !important">
        <div class="col-12 p-3 main-heading-section " [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
          <h1 class="headingattandace">
            All Employee {{model.month_char}} Evaluation
          </h1>
          @if (isavailablefeature('add')) {
            <button class="btn btn-primary" (click)="navigateToAllUsersEvaluation()">
              Add All User Evaluation
            </button>
          }
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-xl-12 col-sm-6 col-12">
          <!-- ------------ 2nd ---------     -->
          <!-- s -->
          <div class="card-body  container-fluid rounded-8  mb-2 "
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="row ">
              <div class=" col-4">
                <input type="text" class="form-control" placeholder="Search by Name" [(ngModel)]="searchText"
                  (keyup)="filterEvaluationsByName()">
                </div>
                <div class=" col-4">
                  <input type="text" class="form-control" placeholder="Search by Designation"
                    [(ngModel)]="searchDesignation" (keyup)="filterEvaluationsByDesignation()">
                  </div>
                  <div class="filter-by-values  col-4">
                    <select [(ngModel)]="selectedOption" (change)="callFunction()">
                      <option [ngValue]="''" hidden selected>Filter</option>
                      <option [ngValue]="'filterReset'">Filter reset</option>
                      <option [ngValue]="'TLPublish'">Team Lead Publish</option>
                      <option [ngValue]="'TLpending'">Team Lead Pending</option>
                      <option [ngValue]="'PMpending'">PM Pending</option>
                      <option [ngValue]="'PMadd'">UNPUBLISHED</option>
                      <option [ngValue]="'PMpublished'">Published</option>
                    </select>
                  </div>
                </div>
                <div class=" row mt-4">
                  <div class="col-8">
                    <form #f="ngForm" (ngSubmit)="onSubmit(f)">
                      <div class="row">
                        <div class="col-6">
                          <input type="text" onfocus="(this.type='month')" onblur="(this.type= this.value ? 'month' : 'text')"
                            placeholder="Search by Month*" class="form-control" name="date" #date="ngModel" ngModel>
                          </div>
                          <div class="col-3">
                            <!-- <div class="btn-date col">  -->
                            <button type="button" class="btn btn-primary reset" (click)="onReset(f)">Reset</button>
                          </div>
                          <div class="col-3">
                            <!-- <div class="btn-apply col"> -->
                            <button type="submit" class="btn btn-primary apply">Apply</button>
                          </div>
                        </div>
                      </form>
                    </div>
                    @if (user_role.role_type === 'Admin') {
                      <div class="col-4">
                        @if (isavailablefeature('update')) {
                          <button class="btn btn-primary publishAll" data-toggle="modal"
                            data-target="#publisModal">
                            Publish All
                          </button>
                        }
                      </div>
                    }
                  </div>
                  <!-- <div class="right-container col-2">
                  <div *ngIf="user_role.role_type === 'Admin'" class="publish-all-btn">
                    <button class="btn btn-primary font-weight-bold mt-1 text-white publish-btn" data-toggle="modal" data-target="#publisModal">
                      Publish All
                    </button>
                  </div>
                </div> -->
              </div>
              <!--e  -->
              @for (item of evaluate; track item) {
                @if (item.evaluation; as eval) {
                  <div class="card shadow mb-2"
                    [ngClass]="{ 'dark-backround': selectedMode === 'dark', 'publish-card': eval.is_evaluation === '1', 'TL-PM-Done-card': eval.pm_points > '0' && eval.points > '0' && eval.is_evaluation === '0', 'pending-card': eval == null || eval.is_evaluation == null, 'Only-TL-Done-card': eval.points > '0' && eval.pm_points == '0' }">
                    <div class="card-content rounded">
                      <!-- <a href=" " class="btn btn text-white   ml-2 mt-3 approved1">Approved</a> -->
                      <div class="card-body">
                        <div class="media d-flex text-center text-secondary salary">
                          <!-- Handle evaluation states safely -->
                          @if (eval.is_evaluation === '1') {
                            <div class="vertical-publish">
                              <span>PUBLISHED </span>
                            </div>
                          }
                          @if (eval == null || eval.is_evaluation == null ) {
                            <div class="vertical-pending">
                              <span> PENDING </span>
                            </div>
                          }
                          @if (eval.points > '0' && eval.pm_points == '0') {
                            <div class="vertical-TL">
                              <span>PM PENDING </span>
                            </div>
                          }
                          <!-- <div class="vertical-TL1" *ngIf="eval.points == '0' && eval.pm_points > '0'">
                          <span>TL PENDING </span>
                        </div> -->
                        @if (eval.pm_points > '0' && eval.points > '0' && eval.is_evaluation === '0') {
                          <div class="vertical-TL-PM"
                            >
                            <span> UNPUBLISHED</span>
                          </div>
                        }
                        <div class="col-4 mt-4">
                          <span>
                            <b style="font-size: 17px">{{item.first_name}}
                              &nbsp;
                            {{item.last_name}}</b></span>
                          </div>
                          <div class="col-3">
                            <span>Designation</span><br />&nbsp;
                            <h6>{{item.description}}</h6>
                          </div>
                          <div class="col-2">
                            <span>TL Rating</span><br />&nbsp;
                            <h6>
                              {{item.percentage || 'N/A'}}
                            </h6>
                          </div>
                          <div class="col-2">
                            <!-- <span>Band</span><br />&nbsp;
                            <h6> {{item.bands || 'N/A'}}</h6> -->
                            <span>PM Ratting</span><br />&nbsp;
                            <h6> {{item.percentage1 || 'N/A'}}</h6>
                          </div>
                          <div class="col-1 mt-1">
                            <a (click)="addEvaluation(item)" style="cursor: pointer;">
                            <img src="assets/aye_icon.svg" width="40px" alt="" /></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
            <!-- modal -->
            <div class="modal fade publisModal pl-0" id="publisModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
              aria-hidden="true" data-backdrop="static" data-keyboard="false">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content publisModal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                  <div class="modal-header publisModal-header justify-content-center">
                    <h1>Confirmation</h1>
                  </div>
                  <div class="modal-body confirm-modal-body text-center publisModal-body"
                    [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
                    <img src="../../../assets/images/question.jpg" alt="image">
                    <p class="my-3">Are you sure you want to Publish All Evaluations?</p>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-danger" data-dismiss="modal">No</button>
                    <button class="btn btn-success" data-dismiss="modal" (click)="conform()">Confirm</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="mt-5" style="height: 404px"></div>
    </main>